import { Link } from "react-router-dom";
import { Play, Clock } from "lucide-react";

export function SermonCard({ sermon, testid }) {
  const thumb = `https://img.youtube.com/vi/${sermon.youtube_id}/hqdefault.jpg`;
  return (
    <Link
      to={`/sermons/${sermon.id}`}
      data-testid={testid || `sermon-card-${sermon.id}`}
      className="ccn-card overflow-hidden group block"
    >
      <div className="relative aspect-video bg-[#2A2E2C] overflow-hidden">
        <img src={thumb} alt={sermon.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A2E2C]/70 to-transparent" />
        <div className="absolute bottom-3 left-3 flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-[#C8664D] flex items-center justify-center text-white shadow-lg">
            <Play className="w-4 h-4 ml-0.5" fill="currentColor" />
          </div>
          {sermon.series && (
            <span className="text-xs text-white tracking-[0.2em] uppercase font-bold bg-black/30 backdrop-blur-sm px-2.5 py-1 rounded-full">
              {sermon.series}
            </span>
          )}
        </div>
      </div>
      <div className="p-5">
        <div className="font-heading text-xl text-[#1E1E1E] leading-snug group-hover:text-[#C8664D] transition-colors line-clamp-2">
          {sermon.title}
        </div>
        <div className="mt-2 text-sm text-[#575A58]">{sermon.speaker}</div>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-[#575A58]">
          <Clock className="w-3.5 h-3.5" />
          {sermon.date ? new Date(sermon.date).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : ""}
        </div>
      </div>
    </Link>
  );
}
